import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { HIDE_BETA_FEATURES } from './config/featureFlags';

import enCommon from './locales/en/common.json';
import enChat from './locales/en/chat.json';
import enSidebar from './locales/en/sidebar.json';
import enFeedback from './locales/en/feedback.json';
import enCrisis from './locales/en/crisis.json';
import enAuth from './locales/en/auth.json';
import enErrors from './locales/en/errors.json';

import hiCommon from './locales/hi/common.json';
import hiChat from './locales/hi/chat.json';
import hiSidebar from './locales/hi/sidebar.json';
import hiFeedback from './locales/hi/feedback.json';
import hiCrisis from './locales/hi/crisis.json';
import hiAuth from './locales/hi/auth.json';
import hiErrors from './locales/hi/errors.json';

export interface SupportedLanguage {
  code: string;
  name: string;
  nativeName: string;
}

const HINDI_LANGUAGE: SupportedLanguage = {
  code: 'hi',
  name: 'Hindi',
  nativeName: 'हिन्दी',
};

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  ...(HIDE_BETA_FEATURES ? [] : [HINDI_LANGUAGE]),
];

const storedLang = (() => {
  try {
    const stored = localStorage.getItem('paila-language') || 'en';
    if (HIDE_BETA_FEATURES && stored === 'hi') return 'en';
    return stored;
  } catch {
    return 'en';
  }
})();

const hiResources = {
  common: hiCommon,
  chat: hiChat,
  sidebar: hiSidebar,
  feedback: hiFeedback,
  crisis: hiCrisis,
  auth: hiAuth,
  errors: hiErrors,
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      chat: enChat,
      sidebar: enSidebar,
      feedback: enFeedback,
      crisis: enCrisis,
      auth: enAuth,
      errors: enErrors,
    },
    ...(HIDE_BETA_FEATURES ? {} : { hi: hiResources }),
  },
  lng: storedLang,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false, // React already escapes
  },
  react: {
    useSuspense: false, // Translations are bundled, no async loading
  },
});

export default i18n;
